module.exports = __webpack_public_path__ + "static/media/up.bf3cb035.svg";